import React, { useEffect, useRef, useState } from 'react';
import { Hidden } from '@material-ui/core';
import { fmtHSS } from 'common/ui/utils';
import MainPlaybar from './MainPlaybar';
import MiniPlaybar from './MiniPlaybar';

import axios from 'axios';

const formatTime = (secs) => {
  let minutes = Math.floor(secs / 60);
  let seconds = Math.ceil(secs - minutes * 60);

  if (seconds < 10) seconds = `0${seconds}`;

  return `${minutes}:${seconds}`;
};

const Playbar = (props) => {
  const {
    id,
    episode,
    title,
    image,
    audioPlayer,
    heartedPodcastIds,
    playlistEpisodeIds,
    onAddPlayPodcastStart,
    onFavouritePodcast,
    onRemoveFavoritePodcastStart,
    onEpisodePlayerStart,
    onQueuePodEpisodeId,
    onShowSnackbarNotification,
    isPodCastClicked
  } = props;
  const player = audioPlayer.current;
  const [audioState, setAudioState] = useState(null);
  const [stateVolume, setStateVolume] = useState(0.3);
  const [previousVolume, setPreviousVolume] = useState(0.3);
  const [currentTime, setCurrentTime] = useState(0);
  const [remainingTime, setRemainingTime] = useState('');
  const [playback, setPlayback] = useState(1);
  const rate = [
    {
      id: 0,
      value: 0.5,
      name: '0.5x'
    },
    {
      id: 1,
      value: 1,
      name: '1x'
    },
    {
      id: 2,
      value: 1.5,
      name: '1.5x'
    },
    {
      id: 3,
      value: 2,
      name: '2x'
    }
  ];
  const playbackRate = rate[rate.findIndex((obj) => obj.id === playback)].name;

  const isHearted = heartedPodcastIds
    ? heartedPodcastIds.some((podcastId) => podcastId === episode['podcast_id'])
    : false;

  const podcastLink = `${window.location.origin}/podcast/${episode['podcast_id']}?podcastid=${episode['podcast_id']}&episodeid=${episode['id']}`;

  const setLoadingStatus = () => {
    setAudioState('loading');
    props.onSetAudioStatus('loading');
  };

  const setPlayingStatus = () => {
    setAudioState('playing');
    props.onSetAudioStatus('playing');
  };

  const setPauseStatus = () => {
    setAudioState('paused');
    props.onSetAudioStatus('paused');
  };

  const setupMediaSessions = () => {
    if ('mediaSession' in navigator) {
      console.log('navigator setupped');

      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: title,
        artwork: [
          {
            src: image,
            sizes: '512x512',
            type: 'image/png'
          }
        ]
      });
      navigator.mediaSession.setActionHandler('play', () => {
        /* Code excerpted. */
        toggleAudio();
      });
      navigator.mediaSession.setActionHandler('pause', () => {
        /* Code excerpted. */
        audioPlayer.current.pause();
      });
      // navigator.mediaSession.setActionHandler('previoustrack', () => {
      //   playPrevious();
      // });
      // navigator.mediaSession.setActionHandler('nexttrack', () => {
      //   playNext();
      // });
    }
  };

  function timeout(ms, promise) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Error('TIMEOUT'));
      }, ms * 1000);

      promise
        .then((value) => {
          clearTimeout(timer);
          resolve(value);
        })
        .catch((reason) => {
          clearTimeout(timer);
          reject(reason);
        });
    });
  }

  const toggleAudio = () => {
    timeout(15, audioPlayer.current.play())
      .then((_) => {
        // Automatic playback started!
        // Show playing UI.
        console.log('audio played auto');
        onAddPlayPodcastStart(episode['podcast_id']);
        setupMediaSessions();
      })
      .catch((error) => {
        // Auto-play was prevented
        // Show paused UI.
        if(isPodCastClicked) {
          onShowSnackbarNotification(`Podcast not Available!`);
        }
        console.log('playback prevented');
        setPauseStatus();
      });
  };

  const playerProgress = (e) => {
    setCurrentTime(e.target.currentTime);
    const duration = player.duration;
    if (duration >= audioPlayer.current.currentTime) {
      const timeFrame = duration - audioPlayer.current.currentTime;
      if (timeFrame < 1) {
        setRemainingTime(fmtHSS(timeFrame));
      } else {
        setRemainingTime('~' + fmtHSS(timeFrame));
      }
    }
  };

  const handleVolume = (event, newValue) => {
    const q = newValue / 100;
    setStateVolume(q);
    setPreviousVolume(q);
    audioPlayer.current.volume = q;
  };

  const handleMute = (isMute) => {
    if (!isMute) {
      setStateVolume(0);
      audioPlayer.current.volume = 0;
    } else {
      setStateVolume(previousVolume);
      audioPlayer.current.volume = previousVolume;
    }
  };

  const handlePlayerProgress = (newValue) => {
    setPlayback(1);
    setCurrentTime(newValue);
    audioPlayer.current.currentTime = newValue;
  };

  const handleBackward = () => {
    const currentTime = audioPlayer.current.currentTime;
    let newTime = currentTime - 15;
    if (newTime < 0) {
      newTime = 0;
    }
    setPlayback(1);
    audioPlayer.current.currentTime = newTime;
  };

  const handleForward = (duration) => {
    const currentTime = audioPlayer.current.currentTime;
    let newTime = currentTime + 30;
    if (newTime > duration) {
      newTime = duration;
    }
    setPlayback(1);
    audioPlayer.current.currentTime = newTime;
  };

  const changePlaybackRate = () => {
    let value = 0;
    const index = rate.findIndex((obj) => obj.id === playback) + 1;
    if (index > rate.length - 1) {
      value = 0;
    } else {
      value = playback + 1;
    }
    setPlayback(value);
    setPlayBack(rate[rate.findIndex((obj) => obj.id === value)].value);
  };

  const setPlayBack = (playbackRate) => {
    audioPlayer.current.playbackRate = playbackRate;
  };

  const onFavouriteClick = () => {
    const id = episode['podcast_id'].toString();
    const index = heartedPodcastIds.indexOf(id);
    if (index === -1) {
      onShowSnackbarNotification(`Podcast Hearted ❤️`);
      onFavouritePodcast(id);
    } else {
      onShowSnackbarNotification(`Podcast Un-hearted 😢`);
      onRemoveFavoritePodcastStart(id);
    }
  };

  useEffect(() => {
    console.log('state changed triggedred');
    const getAudio = async (url, cors) => {
      // audioPlayer.current.src = "";
      // maximize the player every time id changes
      // only if playlist is not open

      setLoadingStatus();
      let URL = url;
      if (cors) {
        URL = 'https://cors-anywhere.herokuapp.com/' + url;
      }
      const res = await axios.get(URL);
      // set the audio data
      console.log('data>>>>>>>');
      console.log(res.data);
      audioPlayer.current.src = res.data;
      toggleAudio();
    };

    console.log('changed url');
    audioPlayer.current.volume = stateVolume;
    if (episode.URL) {
      getAudio(episode.URL, true);
    } else if (episode.audio) {
      setLoadingStatus();
      audioPlayer.current.src = episode.audio;
      toggleAudio();
    } else if (episode.src) {
      setLoadingStatus();
      audioPlayer.current.src = episode.src;
      toggleAudio();
    } else if (props.url) {
      setLoadingStatus();
      audioPlayer.current.src = props.url;
      toggleAudio();
    } else if (episode.enclosureUrl) {
      setLoadingStatus();
      audioPlayer.current.src = episode.enclosureUrl;
      toggleAudio();
    }
  }, [episode, props.url]);

  const showDuration = () => {
    if (player) {
      if (player.duration) {
        return fmtHSS(player.duration);
      } else {
        return '00:00:00';
      }
    } else {
      return 0;
    }
  };

  // this will be fired when song is ended
  const songEnded = () => {
    // if repeat is false we will play next else just set the time to 0
    const index = playlistEpisodeIds.indexOf(id);
    // console.log('index: ', index);
    const nextEpisode = playlistEpisodeIds[index - 1];
    // console.log('nextEpisode: ', nextEpisode);
    if (nextEpisode) {
      onEpisodePlayerStart(episode['podcast_id'], nextEpisode);
      onQueuePodEpisodeId(nextEpisode);
    }
  };

  return (
    <>
      <Hidden xsDown>
        <MainPlaybar
          player={player}
          isHearted={isHearted}
          stateVolume={stateVolume}
          handleVolume={handleVolume}
          handleMute={handleMute}
          audioStatus={audioState}
          currentTime={fmtHSS(currentTime)}
          currentTimeMSS={currentTime}
          remainingTime={remainingTime}
          duration={player ? player.duration : 0}
          totalLength={showDuration()}
          podcastLink={podcastLink}
          toggleAudio={toggleAudio}
          handlePlayerProgress={handlePlayerProgress}
          handleBackward={handleBackward}
          handleForward={handleForward}
          onFavouriteClick={onFavouriteClick}
          playbackRate={playbackRate}
          changePlaybackRate={changePlaybackRate}
          {...props}
        />
      </Hidden>
      <Hidden smUp>
        <MiniPlaybar
          player={player}
          isHearted={isHearted}
          stateVolume={stateVolume}
          handleVolume={handleVolume}
          audioStatus={audioState}
          currentTime={fmtHSS(currentTime)}
          currentTimeMSS={currentTime}
          remainingTime={remainingTime}
          duration={player ? player.duration : 0}
          totalLength={showDuration()}
          podcastLink={podcastLink}
          toggleAudio={toggleAudio}
          handlePlayerProgress={handlePlayerProgress}
          handleBackward={handleBackward}
          handleForward={handleForward}
          onFavouriteClick={onFavouriteClick}
          playbackRate={playbackRate}
          changePlaybackRate={changePlaybackRate}
          {...props}
        />
      </Hidden>
      <audio
        onTimeUpdate={(e) => playerProgress(e)}
        onCanPlay={() => setPlayBack(1)}
        onLoadStart={() => isPodCastClicked && setLoadingStatus()} // here main issue
        id="audio-element"
        onPlay={() => setPlayingStatus()}
        onPlaying={() => setPlayingStatus()}
        onPause={() => setPauseStatus()}
        onEnded={songEnded}
        autoPlay
        ref={audioPlayer}
      />
    </>
  );
};

export default Playbar;
